import styled from 'styled-components';

export const ConvertUserIdsTextArea = styled.textarea`
  width: 960px;
  height: 300px;
  resize: none;
`;
